import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch, GetState } from 'tradera/state/configure-store';
import { setValue } from 'tradera/state/member-storage/reducer';
import type { MemberServerStorageListApiResponse } from 'tradera/state/services/types/webapi-member-generated';
import { webApiClient } from 'tradera/utils/http';

export const loadMemberServerStorageData = createAsyncThunk(
    'memberStorage/loadMemberServerStorageData',
    async () => {
        const respone =
            await webApiClient.get<MemberServerStorageListApiResponse>(
                '/member/server-storage',
            );
        return respone.data;
    },
);

export const saveMemberServerStorageValue =
    (key: string, value: string) =>
    async (dispatch: AppDispatch, getState: GetState) => {
        const currentValue = getState().memberStorage.data[key];
        // no need to save if value is the same
        if (currentValue === value) {
            return;
        }
        dispatch(setValue({ key, value }));
        const response = await webApiClient.put('/member/server-storage', {
            key,
            value,
        });
        return response;
    };
